// extracted by mini-css-extract-plugin
module.exports = {"Form":"FormComponent_Form__3-3w0","content":"FormComponent_content__D1PRY"};